const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        // sorter: (a, b) => a.firstName - b.firstName,
    },
    {
        title: 'Commission',
        dataIndex: 'commissionAmount',
        // sorter: (a, b) => a.commissionAmount - b.commissionAmount,
    },
    {
        title: 'Request Date',
        dataIndex: 'transactionDate',
        // sorter: (a, b) => a.transactionDate - b.transactionDate,
    },
    {
        title: 'Status',
        dataIndex: 'status',
    }
];

export default columns;